import { colorHelper } from "../ColorHelper";
import { RetailItemVariant } from "../../../Models/Retail/RetailItem";
import { LocalStorageKeyCollection } from "../../Constants/KeyCollection/LocalStorageKeyCollection";

export class retailHelper {
    setColorPickerColors(colorFilters: JQuery<HTMLElement>) {
        let colorPicker = new colorHelper();
        
        for (let e of colorFilters) {
            let $e = $(e);
            let bgColor = colorPicker.stringToRgb($e.css('background-color'));

            let whiteLumi = colorPicker.calculateRatio(bgColor, { r: 255, g: 255, b: 255 });
            let darkLumi = colorPicker.calculateRatio(bgColor, { r: 75, g: 75, b: 75 });
            //console.log(`${$e.css('background-color')}::${whiteLumi} <-> ${darkLumi}`);

            if (darkLumi > whiteLumi) {
                $e.addClass('retail__filter_color--inverted');
            }

            if (whiteLumi === 1) {
                $e.addClass('retail__filter_color--bordered');
            }
        }
    }

    checkReload(reloadCallback: (storageFilter: RetailItemVariant[]) => void, productIndicator: number, detail?: boolean): boolean {
        detail = detail || false;
        let performanceTypes = window.performance
            .getEntriesByType('navigation')
            .map((nav: PerformanceNavigationTiming) => nav.type);
        const pageAccessedByReload = (
            (window.performance.navigation &&
                    (window.performance.navigation.type === 1 || window.performance.navigation.type === 2)) ||
                performanceTypes.includes('reload') ||
                performanceTypes.includes('back_forward')
        );

        if (pageAccessedByReload) {
            let storageFilter: RetailItemVariant[] = JSON.parse(window.localStorage.getItem(
                (detail
                    ? LocalStorageKeyCollection.retailDetailStorageKey
                    : LocalStorageKeyCollection.retailFilterStorageKey).replace('{0}', productIndicator.toString())));
            reloadCallback(storageFilter);
            return storageFilter != null && storageFilter.length > 0;
        } else {
            this.saveToLocalStorage([], productIndicator, detail);
        }
        return false;
    }

    saveToLocalStorage(filterList: RetailItemVariant[], productIndicator: number, detail?: boolean) {
        detail = detail || false;
        window.localStorage.setItem((detail ? LocalStorageKeyCollection.retailDetailStorageKey : LocalStorageKeyCollection.retailFilterStorageKey).replace('{0}', productIndicator.toString()), JSON.stringify(filterList));
    }

}